import rankTypeCounts from '@UI/Pages/Home/DocumentsBlock/Helpers/rankTypeCounts';
import resolveTypeSeries, { type TypeSeries } from '@UI/Pages/Home/DocumentsBlock/Helpers/resolveTypeSeries';
import type DocumentTypesListView from '@UI/Store/DocumentTypes/Views/DocumentTypesListView';
import type DocumentTypeCountView from '@UI/Store/Indicators/Views/DocumentTypeCountView';

/** Series of every type present in the breakdown; a type without documents has no entry (hollow dot). */
const buildTypeSeriesMap = (
	byType: readonly DocumentTypeCountView[],
	documentTypes: DocumentTypesListView | null,
): ReadonlyMap<number, TypeSeries> =>
	new Map(
		rankTypeCounts(byType, documentTypes).map((entry) => [
			entry.documentTypeId,
			resolveTypeSeries(entry.rank, entry.isArchived),
		]),
	);

export default buildTypeSeriesMap;
